import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight, Check, User, MapPin, CheckCircle, CreditCard } from 'lucide-react';
import './step.css';
import DeliveryAddress from '../../shipping/DeliveryAddress';
import PersonalInformation from '../personalInformation/PersonalInformation';
import Confirm from '../confirm/Confirm';
import PersonalInfo from '../personalInformation/PersonalInfo';
import SimpleReactLightbox from 'simple-react-lightbox';
import HeadMeta from '../../../helmet/HeadMeta/HeadMeta';
import AppBar from '../../AppBar';
import { connect } from 'react-redux';
import PaymentTypeSection from '../../shipping/PaymentTypeSection';
import { getDeposit, set_me } from '../../../actions/user';
import { getBasket } from '../../../actions/cartActions';

const MultiStepForm = ({ user }) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState({
    fullName: '',
    phoneNumber: '',
    email: '',
    nationalCode: '',
    address: '',
    city: '',
    postalCode: '',
    deliveryMethod: 'standard',
    deliveryNote: '',
    agreeToTerms: false,
  });
  const steps =
    user['is_deposit'] !== 1
      ? [
          {
            id: 1,
            title: 'مشخصات کاربر',
            icon: User,
            description: 'اطلاعات شخصی خود را وارد کنید',
          },
          {
            id: 2,
            title: 'آدرس و ارسال',
            icon: MapPin,
            description: 'اطلاعات تحویل را تکمیل کنید',
          },
          {
            id: 3,
            title: 'تایید نهایی',
            icon: CheckCircle,
            description: 'بررسی و تایید اطلاعات',
          },
        ]
      : [
          {
            id: 1,
            title: 'مشخصات کاربر',
            icon: User,
            description: 'اطلاعات شخصی خود را وارد کنید',
          },
          {
            id: 2,
            title: 'آدرس و ارسال',
            icon: MapPin,
            description: 'اطلاعات تحویل را تکمیل کنید',
          },
          {
            id: 3,
            title: 'شیوه پرداخت',
            icon: CreditCard,
            description: 'بررسی و تایید اطلاعات',
          },
          {
            id: 4,
            title: 'تایید نهایی',
            icon: CheckCircle,
            description: 'بررسی و تایید اطلاعات',
          },
        ];

  // خواندن استپ از URL
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const stepFromUrl = urlParams.get('step');
    if (stepFromUrl) {
      const stepNumber = parseInt(stepFromUrl);
      if (stepNumber >= 1 && stepNumber <= 3) {
        setCurrentStep(stepNumber);
      } else {
        setCurrentStep(1);
      }
    }

    set_me();
    getBasket();
    getDeposit();
  }, []);

  // آپدیت URL
  const updateURL = (step) => {
    const url = new URL(window.location);
    url.searchParams.set('step', step.toString());
    window.history.pushState({}, '', url);
  };

  const scrollToTop = () => {
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }, 100);
  };

  const nextStep = () => {
    if (currentStep < 4) {
      const newStep = currentStep + 1;
      setCurrentStep(newStep);
      updateURL(newStep);
      scrollToTop();
    }
  };

  const prevStep = () => {
    if (currentStep > 1) {
      const newStep = currentStep - 1;
      setCurrentStep(newStep);
      updateURL(newStep);
      scrollToTop();
    }
  };

  const goToStep = (stepNumber) => {
    if (stepNumber <= currentStep) {
      setCurrentStep(stepNumber);
      updateURL(stepNumber);
    }
  };

  const renderStepContent = () => {
    switch (currentStep) {
      case 1:
        return <PersonalInfo nextStep={nextStep} />;

      case 2:
        return <DeliveryAddress nextStep={nextStep} />;

      case 3:
        return user['is_deposit'] !== 1 ? <Confirm prevStep={prevStep} /> : <PaymentTypeSection nextStep={nextStep} />;

      case 4:
        return <Confirm prevStep={prevStep} />;

      default:
        return null;
    }
  };

  return (
    <SimpleReactLightbox>
      <HeadMeta tabTitle='سبد خرید' />

      <div className='marketplace-appbar-wrapper'>
        <AppBar />
      </div>

      <div className='step-container' dir='rtl'>
        <div className='step-card'>
          {/* Header */}

          {/* Step Indicator */}
          <div className='step-indicator'>
            <div className='step-progress'>
              {steps.map((step, index) => {
                const Icon = step.icon;
                const isActive = currentStep === step.id;
                const isCompleted = currentStep > step.id;
                const canClick = step.id <= currentStep;

                return (
                  <React.Fragment key={step.id}>
                    <div className='step-item'>
                      <div className={`step-icon ${isCompleted ? 'completed' : isActive ? 'active' : 'inactive'}`} onClick={() => canClick && goToStep(step.id)}>
                        {isCompleted ? <Check size={24} /> : <Icon size={24} />}
                      </div>

                      <h3 className={`step-label ${isActive ? 'active' : isCompleted ? 'completed' : 'inactive'}`}>{step.title}</h3>
                    </div>

                    {index < steps.length - 1 && (
                      <div className={`step-line ${currentStep > step.id ? 'completed' : ''}`}>
                        <div className='step-line-progress' />
                      </div>
                    )}
                  </React.Fragment>
                );
              })}
            </div>

            {/* Content */}
            <div className='step-content'>
              <div className='step-content-header'>
                {/* <h2 className='step-content-title'>{steps[currentStep - 1].title}</h2> */}
                {/* <p className='step-content-description'>{steps[currentStep - 1].description}</p> */}
              </div>

              {renderStepContent()}
            </div>

            {/* Navigation */}
            {/* <div className='step-navigation'>
            <button onClick={prevStep} disabled={currentStep === 1} className='step-button step-button-prev'>
              <ChevronRight className='step-button-icon' style={{ marginLeft: '8px' }} />
              مرحله قبل
            </button>

            {currentStep < 3 ? (
              <button onClick={nextStep} className='step-button step-button-next'>
                مرحله بعد
                <ChevronLeft className='step-button-icon' style={{ marginRight: '8px' }} />
              </button>
            ) : (
              <button onClick={submitForm} disabled={!formData.agreeToTerms} className='step-button step-button-submit'>
                <CheckCircle className='step-button-icon' style={{ marginLeft: '8px' }} />
                تکمیل فرآیند
              </button>
            )}
          </div> */}
          </div>
        </div>
      </div>
    </SimpleReactLightbox>
  );
};
const MapStateToProps = (state) => ({
  user: state.user,
});

export default connect(MapStateToProps)(MultiStepForm);
